import { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { config } from '../utils/config';
import { useAuthStatus } from '../store/auth/useAuthStatus';

function PrivateRoute({ component: Component, ...rest }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { loginState } = useAuthStatus();

  useEffect(() => {
    if (loginState) {
      setIsLoggedIn(true);
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Component getUserInfo={rest?.getUserInfo} {...props} search={''} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
